import React from 'react';
import { Link } from 'react-router-dom';
import programUnggulan from '../data/programUnggulan';
import '../styles/ProgramUnggulan.css';

const ProgramUnggulanSection = () => {
  return (
    <section className="section program-unggulan">
      <div className="container">
        <div className="section-title">
          <h2>Program Unggulan</h2>
          <p>
            Kami menyediakan berbagai program unggulan untuk mendukung akses 
            pendidikan tinggi kesehatan yang berkualitas
          </p>
        </div>

        <div className="unggulan-grid">
          {programUnggulan.map((program) => (
            <div key={program.id} className="unggulan-card">
              <div 
                className="unggulan-icon" 
                style={{ background: `${program.warna}20` }}
              >
                {program.icon}
              </div>
              <h3>{program.nama}</h3>
              <span className="unggulan-singkatan">{program.singkatan}</span>
              <p className="unggulan-desc">{program.deskripsi}</p>
              
              <div className="unggulan-list">
                <h4>Manfaat:</h4>
                <ul>
                  {program.manfaat.slice(0, 4).map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>

              <Link to="/pendaftaran" className="btn btn-primary">
                Pelajari Lebih Lanjut
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProgramUnggulanSection;
